import React from "react";
import { useLocalStorage } from "../../Hooks/useLocalStorage";

export const CasesContext = React.createContext({
  activeTab: {},
  setActiveTab: () => {},
  activeNav: {},
  setNavResetTab: () => {},
  filterBy: {},
  localActiveNav: {},
  setLocalActiveNav: () => {},
  localActiveTab: {},
  setLocalActiveTab: () => {},
  checkedCases: [],
  setCheckedCases: () => {},
});

export const CasesProvider = (props) => {
  const { top } = props;
  const [localActiveTab, setLocalActiveTab] = useLocalStorage(
    "localActiveTab",
    {
      ui_name: "Initiated",
      machine_name: "Initiated",
    }
  );
  const [localActiveNav, setLocalActiveNav] = useLocalStorage(
    "localActiveNav",
    top
  );
  const [activeTab, setActiveTab] = React.useState(localActiveTab);
  const [activeNav, setActiveNav] = React.useState(localActiveNav);
  const [filterBy, setFilterBy] = React.useState({});
  const [checkedCases, setCheckedCases] = React.useState([]);
  const setNavResetTab = (nav) => {
    setActiveTab({ ui_name: "Initiated", machine_name: "Initiated" });
    setActiveNav(nav);
    setLocalActiveNav(nav);
    setFilterBy({});
    setCheckedCases([]);
  };
  return (
    <CasesContext.Provider
      value={{
        activeTab,
        setActiveTab,
        activeNav,
        setNavResetTab,
        filterBy,
        setFilterBy,
        setLocalActiveTab,
        setLocalActiveNav,
        checkedCases,
        setCheckedCases,
      }}
    >
      {props.children}
    </CasesContext.Provider>
  );
};
